module.exports = __webpack_public_path__ + "static/media/gabriel-baranski-vGICUyYW2CE-unsplash.79c1f329.jpg";